import React from 'react';
import DevicesFormState from './devicesFormState/DevicesFormState';
import AssignDevicesControlPanel from './components/AssignDevicesControlPanel/AssignDevicesControlPanel';
import AssignDevicesList from './components/AssignDevicesList/AssignDevicesList';
import AssignDevicesPagination from './components/AssignDevicesPagination/AssignDevicesPagination';
import BtnBlock from './components/BtnBlock';
import ModalWindows from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './DevicesForm.module.scss';

interface IDevicesForm {
	isVisible: boolean;
}

const DevicesForm: React.FC<IDevicesForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<DevicesFormState>
				<AssignDevicesControlPanel />
				<AssignDevicesList />
				<AssignDevicesPagination />
				<BtnBlock />
				<ModalWindows />
			</DevicesFormState>
		</div>
	);
};

export default React.memo(DevicesForm);
